import React from 'react';

function Join(props) {
  return (
    <div>
      <h2>회원인증</h2>
    </div>
  );
}

export default Join;